import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatperiodiqueComponent } from './statperiodique.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule, MatDatepickerModule, MatFormFieldModule, MatSelectModule, MatListModule, MatTableModule, MatPaginatorModule } from '@angular/material';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { QuickInfoWidgetModule } from '../dashboard/widgets/quick-info-widget/quick-info-widget.module';
import { ListModule } from 'src/@fury/shared/list/list.module';

@NgModule({
  declarations: [StatperiodiqueComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    ListModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatListModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
    QuickInfoWidgetModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FurySharedModule,
  ]
})
export class StatperiodiqueModule { }
